import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./layout/notabs/notabs.module').then(m => m.NotabsPageModule),
  },
  {
    path: '',
    loadChildren: () => import('./layout/tabs/tabs.module').then(m => m.TabsPageModule),
  },
  {
    path: 'tabs',
    loadChildren: () => import('./layout/tabs/tabs.module').then(m => m.TabsPageModule),
  },
  {
    path: 'notabs',
    loadChildren: () => import('./layout/notabs/notabs.module').then(m => m.NotabsPageModule),
  },
  {
    path: 'landing-page',
    loadChildren: () => import('./pages/landing-page/landing-page.module').then( m => m.LandingPagePageModule)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./pages/privacy/privacy.module').then( m => m.PrivacyPageModule)
  },
  // catch if url does not exists and redirects to home
  {
    path: '**',
    redirectTo: '/home'
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
